import React from 'react';
import FFLinkButton from '../buttons/FFLinkButton';
import styles from './DropdownPreviewItem.module.css';

/**
 *
 * @param {object} props
 * @param {FF.HeaderNavPreviewItem} props.navItem
 */
export default function DropdownPreviewItem({ navItem }) {
  return (
    <li className={styles.wrapper}>
      <div className={styles.content}>
        <navItem.ImageComponent className={styles.image} />
        <div>
          <h4 className={styles.title}>{navItem.title}</h4>
          <p className={styles.copy}>{navItem.copy}</p>
        </div>
      </div>
      <FFLinkButton
        className={styles.button}
        buttonType="secondary"
        href={navItem.url}
      >
        {navItem.label}
      </FFLinkButton>
    </li>
  );
}
